module.exports = __webpack_public_path__ + "static/img/Awin2.f91c956f.jpeg";